var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNoDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.1429 23.2857V9.82852L12.6858 23.2857H26.1429Z",
    fill: "#067FE5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1429 17.9143L15.0571 49H43.2857C44.8571 49 46.1429 47.7143 46.1429 46.1429V17.9143Z",
    fill: "#067FE5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4286 49C10.7941 49 11.1596 48.8605 11.4386 48.5815L48.5815 11.4386C49.1395 10.8806 49.1395 9.97656 48.5815 9.41853C48.0234 8.86049 47.1194 8.86049 46.5614 9.41853L45.6758 10.3041C45.1646 9.52185 44.2847 9 43.2857 9H29V23.2857C29 24.8571 27.7143 26.1429 26.1429 26.1429H11.8571V44.1228L9.41853 46.5614C8.86049 47.1194 8.86049 48.0234 9.41853 48.5815C9.69754 48.8605 10.0631 49 10.4286 49Z",
    fill: "#067FE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoDocument);
export default __webpack_public_path__ + "static/media/icon-no-document.2f11c1518b8ed53ccda5ec4afc7e9629.svg";
export { ForwardRef as ReactComponent };